import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import { FieldBaseStateless } from '@atlaskit/field-base';
import TagGroup from '@atlaskit/tag-group';
import Tag from '@atlaskit/tag';
import ExpandIcon from '@atlaskit/icon/glyph/chevron-down';
import Spinner from '@atlaskit/spinner';
import { Content, Expand, Input, TriggerDiv } from '../styled/Trigger';
import { mapAppearanceToFieldBase } from '../internal/appearances'; // =============================================================
// NOTE: Duplicated in ./internal/appearances until docgen can follow imports.
// -------------------------------------------------------------
// DO NOT update values here without updating the other.
// =============================================================

var Trigger = /*#__PURE__*/function (_PureComponent) {
  _inherits(Trigger, _PureComponent);

  var _super = _createSuper(Trigger);

  function Trigger() {
    _classCallCheck(this, Trigger);

    return _super.apply(this, arguments);
  }

  _createClass(Trigger, [{
    key: "render",
    value: // disabled because all of the accessibility is handled manually

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          filterValue = _this$props.filterValue,
          handleItemRemove = _this$props.handleItemRemove,
          handleOnChange = _this$props.handleOnChange,
          handleTriggerClick = _this$props.handleTriggerClick,
          inputRefFunction = _this$props.inputRefFunction,
          icon = _this$props.icon,
          isDisabled = _this$props.isDisabled,
          isFocused = _this$props.isFocused,
          isInvalid = _this$props.isInvalid,
          invalidMessage = _this$props.invalidMessage,
          isLoading = _this$props.isLoading,
          isRequired = _this$props.isRequired,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          placeholder = _this$props.placeholder,
          selectedItems = _this$props.selectedItems,
          tagGroupRefFunction = _this$props.tagGroupRefFunction;
      return /*#__PURE__*/React.createElement(FieldBaseStateless, {
        appearance: mapAppearanceToFieldBase(appearance),
        isDisabled: isDisabled,
        isFitContainerWidthEnabled: true,
        isDialogOpen: isFocused,
        isFocused: isFocused,
        isInvalid: isInvalid,
        invalidMessage: invalidMessage,
        isPaddingDisabled: true,
        isRequired: isRequired,
        onBlur: onBlur,
        onFocus: onFocus
      }, /*#__PURE__*/React.createElement(TriggerDiv, {
        isDisabled: isDisabled,
        onClick: handleTriggerClick
      }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(TagGroup, {
        ref: tagGroupRefFunction
      }, selectedItems.map(function (item) {
        return /*#__PURE__*/React.createElement(Tag, {
          appearance: item.tag ? item.tag.appearance : undefined,
          elemBefore: item.tag ? item.tag.elemBefore : undefined,
          key: item.value,
          onAfterRemoveAction: function onAfterRemoveAction() {
            handleItemRemove(item);
          },
          removeButtonText: isDisabled ? undefined : "".concat(item.content, ", remove"),
          text: item.content
        });
      }), isDisabled ? null : /*#__PURE__*/React.createElement(Input, {
        disabled: isDisabled,
        onChange: handleOnChange,
        placeholder: placeholder,
        innerRef: inputRefFunction,
        type: "text",
        value: filterValue
      }))), /*#__PURE__*/React.createElement(Expand, null, isFocused && isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : icon)));
    }
    /* eslint-enable jsx-a11y/no-static-element-interactions */

  }]);

  return Trigger;
}(PureComponent);

_defineProperty(Trigger, "defaultProps", {
  isDisabled: false,
  isLoading: false,
  onClick: function onClick() {},
  icon: /*#__PURE__*/React.createElement(ExpandIcon, {
    label: ""
  })
});

export { Trigger as default };